import styled from 'styled-components';
import {
  SelectOptions as ECSelectOptions,
  Option as ECOption,
  SelectButton as ECSelectButton,
} from '@econsult/econsult-ui/dist/components/Select';
import { Tick as ECTick } from '@econsult/econsult-ui/dist/components/TopBar/TopBarStyles';

export const SelectButton = styled(ECSelectButton)`
  display: flex;
  gap: 0.5rem;
  width: 100%;
  min-width: 29ch;
  justify-content: space-between;
  padding: 12px 10px 12px 16px;
  height: 38px;
  margin-left: 0;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colorNeutralNeutral7};
  text-align: left;
  
  span {
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;

export const SelectOptions = styled(ECSelectOptions)`
  width: 100%;
`;

export const Option = styled(ECOption)`
  display: flex;
  gap: 0.5rem;
  justify-content: space-between;
`;

export const Tick = styled(ECTick)`
  color: ${({ theme }) => theme.colorStatusSuccess};
  visibility: ${({ isVisible }) => (isVisible ? 'visible' : 'hidden')};
`;
